/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VoxtralFabUrlRequest } from '../../models/voxtral-fab-url-request';

export interface ApiBroadcastVoxtralFabUrlPost$Params {
      body?: VoxtralFabUrlRequest
}

export function apiBroadcastVoxtralFabUrlPost(http: HttpClient, rootUrl: string, params?: ApiBroadcastVoxtralFabUrlPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiBroadcastVoxtralFabUrlPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiBroadcastVoxtralFabUrlPost.PATH = '/api/Broadcast/voxtral-fab-url';
